module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalValue),
      expression: "internalValue"
    }],
    attrs: {
      "name": _vm.name,
      "id": _vm.id
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.internalValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handleChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._v(" "), _vm._l((_vm.options), function(op, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": op.value || op
      }
    }, [_vm._v(_vm._s(op.name || op))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e3a5d60","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/Select.vue
// module id = 1700
// module chunks = 6